import {Group} from '~/app/core/reports/models/group';

export class Chain extends Group {

    chainID: string;
    storeID: string;
    field: string;

    storeGroups: string[];
    get numberStore() {
      return +this.storeID;
    }
    get chainStoreCombo() {
    return `${this.chainID} - ${this.storeID}`;
    }

    get value() {
      return `${this.storeID}  ${this.chainID}`;
    }

  toString() {
    return this.field;
  }
}
